/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box'; 
import Typography from '@mui/material/Typography'; 
import { IconButton, } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
// import { ExecutionPlan } from './ExecutionPlan';
import EditIcon from '@mui/icons-material/Edit';
import './ParameterNode.css'
import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { CustomInput, CustomSwitch, HorizontalNavbar, SidePopover, useAppDispatch, useAppSelector, useEffectOnce } from '../../../globalUtils/globalExports';
import { toast } from 'react-toastify';
import TriggerPointSidePopover, { isOperator } from './TriggerPointSidePopover';
import { ExecutionPlan, ExecutionPlanTrigger } from './ExecutionPlan';
import { ICustomTriggerCondition, parseOptionValues } from './CustomTriggerConditionComponent';
import { cloneDeep, isInteger, startCase } from 'lodash';
import { fetchAdvanceRuleEngineArithmeticOperatorsReferenceData, fetchAdvanceRuleEngineRelationalOperatorReferenceData, fetchAdvanceRuleEngineTriggerParameterReferenceData, getReferenceDataReducer } from '../../../rmsReduxStore/reduxExports';
// import TriggerPointSidePopover from './TriggerPointSidePopover';
import CloseIcon from '@mui/icons-material/Close';

interface ParameterNodeProps {
  data: {
    label?: string;
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    removeNode: Function;
  };
}

const ParameterNode: React.FC<ParameterNodeProps> = (props) => {

  const dispatch = useAppDispatch();
  const { executionPlan, handleUpdateExecutionPlan, removeNode } = props.data;
  const [isTriggerParameterPopoverOpen, setIsTriggerParameterPopoverOpen] = useState(false);
  const {advanceRuleEngineArithmeticOperatorReferenceData,advanceRuleEngineRelationalOperatorReferenceData,advanceRuleEngineTriggerParameterReferenceData} = useAppSelector(getReferenceDataReducer);
  const [activeTab,setActiveTab] = useState<'occurences'|'persistence'>('occurences');

  const tabs = [
    {
      id: 'occurences',
      text: 'Occurences'
    },
    {
      id: 'persistence',
      text: 'Persistence'
    }
  ]


  useEffectOnce(()=>{
    dispatch(fetchAdvanceRuleEngineArithmeticOperatorsReferenceData());
    dispatch(fetchAdvanceRuleEngineRelationalOperatorReferenceData());
    dispatch(fetchAdvanceRuleEngineTriggerParameterReferenceData());
  })

  useEffect(()=>{
    if(executionPlan?.trigger?.occurrenceLogic === 'advance' && executionPlan?.trigger?.waitTimePeriod)setActiveTab('persistence');
  },[executionPlan?.trigger])

  const operatorRef = useMemo(()=>{
      const arithmeticOperators = advanceRuleEngineArithmeticOperatorReferenceData ?? [];
      const relationalOperators = advanceRuleEngineRelationalOperatorReferenceData ?? [];
      return [...relationalOperators,...arithmeticOperators];
  },[advanceRuleEngineArithmeticOperatorReferenceData,advanceRuleEngineRelationalOperatorReferenceData])

  const handleEdit =() => {
    setIsTriggerParameterPopoverOpen(true);
  }
  const handleCloseTriggerParameterPopover = () =>{
    setIsTriggerParameterPopoverOpen(false);
  }

  const validConsecutiveSession = (trigger: ExecutionPlanTrigger) => {
    return (trigger.conditions?.length === 1 && trigger?.conditions?.[0]?.triggerParamType === 'SESSION');
  }

  // The persistence logic changed earlier it was applicable only for one Alarm now there is no
  // such restriction. Note - we will check if the entire condition exists for that time  
  const enablePersistenceTab = (trigger: ExecutionPlanTrigger) => {
    // return (trigger.conditions?.length === 1 && trigger?.conditions?.[0]?.triggerParamType === 'ALARMS');
    return true;
  }

  const handleTabClick = useCallback((val) => {
    const data = cloneDeep(executionPlan);
    if (val === 'persistence' && !enablePersistenceTab(data?.trigger)) {
      // This check is technically redundant because navigation clicks for
      // disabled tabs are already blocked in the HorizontalNavbar component.
      // It is retained here as an additional safety guard.
      return;
    }
    if ( val === 'persistence' ) {
      data.trigger.numberOfOccurrences =  null;
      data.trigger.timePeriod = null;
      data.trigger.timeUnit = null;
      data.trigger.isConsecutive = null;
    } else {
      data.trigger.waitTimePeriod = null;
      data.trigger.waitTimeUnit = null;
    }
    setActiveTab(val);
    handleUpdateExecutionPlan(data);

  },[executionPlan]);


  const handleAdvanceLogicUpdate = (key:string, value: number | string | boolean) : void => {
    const data = cloneDeep(executionPlan);
    if ( key === 'occurrenceLogic' ) {
        data.trigger.occurrenceLogic = value as string

        if( value === 'basic' ) {
          data.trigger.numberOfOccurrences =  null
          data.trigger.timePeriod = null
          data.trigger.timeUnit = null
          data.trigger.waitTimePeriod = null
          data.trigger.waitTimeUnit = null
        }
    }
    else if (key==='timeUnit'){
      data.trigger.timeUnit = value as string;
    }
    else if (key === 'isConsecutive') {
      if(!validConsecutiveSession(data?.trigger)){
        data.trigger.isConsecutive = null;
      }
      else {
        data.trigger.isConsecutive = value as boolean;
      }
    }
    else if (key === 'waitTimePeriod') {
      if(value === '' || isNaN(Number(value)) ) {
        data.trigger.waitTimePeriod = null;
        data.trigger.waitTimeUnit = null;
      }else {
        if (String(value).includes('.')) {
          toast.warn('Decimal values are not allowed');
          return;
        }
        if (String(value).length > 5) {
          toast.warn('Wait Time Period cannot exceed 5 digits');
          return;
        }
        data.trigger.waitTimePeriod = Number(value);
        data.trigger.waitTimeUnit = 'minute'
      }
      
    }
    else {
      if(value === '' || isNaN(Number(value)) ) data.trigger[key] = null;
      else {
        if (String(value).includes('.')) {
          toast.warn('Decimal values are not allowed');
          return;
        }
        if (key === 'numberOfOccurrences' && String(value).length > 3) {
          toast.warn('Number of Occurrences cannot exceed 3 digits');
          return;
        }
        if (key === 'timePeriod' && String(value).length > 5) {
          toast.warn('Time Period cannot exceed 5 digits');
          return;
        }
        data.trigger[key] = Number(value); 
      }
    }

    handleUpdateExecutionPlan(data);
  }

  const toggleSwitchConfig = {
    checked: executionPlan?.trigger?.occurrenceLogic === 'advance',
    switchLabelName: null,
    disableSwitchLabelName: executionPlan?.trigger?.occurrenceLogic === 'basic' ? 'Disable' : 'Enable',
    handleClick: () => {
      const val = executionPlan?.trigger?.occurrenceLogic === 'basic' ? 'advance' : 'basic';
      handleAdvanceLogicUpdate('occurrenceLogic',val);
    },
    isDisabled: false
  };

  const consecutiveSessionToggleSwitchConfig = {
    checked: executionPlan?.trigger?.isConsecutive === true,
    switchLabelName: null,
    disableSwitchLabelName: null,
    handleClick: () => {
      const val = executionPlan?.trigger?.isConsecutive ? false : true;
      handleAdvanceLogicUpdate('isConsecutive',val);
    },
    isDisabled: !validConsecutiveSession(executionPlan?.trigger)
  }

  const advanceLogicParams = [
    {
      id: 'noOfOccurrence',
      label: 'Number of Occurences (X)',
      value: executionPlan?.trigger?.numberOfOccurrences,
      onValueChange: (val)=>{handleAdvanceLogicUpdate('numberOfOccurrences',val)},
      valueType: 'input',
      description: 'Rule executes on the Xth occurence'
    },
    {
      id: 'timePeriodValue',
      label: 'Time Period Value (Y)',
      value: executionPlan?.trigger?.timePeriod,
      onValueChange: (val)=>{handleAdvanceLogicUpdate('timePeriod',val)},
      valueType: 'input',
      description: 'For monitoring occurrence count'
    },
    {
      id: 'timeUnit',
      label: 'Time Unit',
      value: executionPlan?.trigger?.timeUnit,
      onValueChange: (val)=>{handleAdvanceLogicUpdate('timeUnit',val)},
      valueType: 'select',
      description: null,
      options: [{id:'minute',name:'Minutes'},{id:'hour',name:'Hours'},{id:'day',name:'Days'},{id:'week',name:'Weeks'}].map(item=>({id:item?.id,name:item?.name,label:item?.name,value:item?.id}))
    },

  ]

  const persistanceLogicParams = [
    {
      id: 'waitTimePeriod',
      label: 'Condition Exists for (mins)',
      value: executionPlan?.trigger?.waitTimePeriod,
      onValueChange: (val)=>{handleAdvanceLogicUpdate('waitTimePeriod',val)},
      valueType: 'input',
      description: ''
    }
  ]

  const getCondition = (label:string) => {

    const condition: ICustomTriggerCondition = executionPlan?.trigger?.conditions?.filter(item=>item.triggerCondName === label)?.[0];
    const parameter = advanceRuleEngineTriggerParameterReferenceData?.find(item => item.parameterKey === condition?.triggerParamId);
    const enumValues = condition?.isTriggerParamTypeEnum ? parseOptionValues(parameter?.possibleValue??null,parameter?.numberKeyFormat??'') : [];

    if(condition?.isDerived) {
      return  <div className='trigger-condition-container'>
        <span className='trigger-condition-normal'>{'Derived Condition ('}</span>
        <span className='trigger-condition-bold'>&quot;{condition?.triggerParamLabel}&quot;</span>
        <span className='trigger-condition-normal'>{')'}</span>
      </div>
    }

    const value = condition?.arithmeticParamId ? <>
      <span className='trigger-condition-bold'>&quot;{condition?.arithmeticParamLabel}&quot;</span>
      <span className='trigger-condition-normal'>{operatorRef?.filter(item => item?.id === condition?.arithmeticOperator)?.[0]?.id}</span>
      <span className='trigger-condition-bold'>{condition?.arithmeticParamValue}</span>
      { condition?.arithmeticParamUnit && <span className='trigger-condition-bold'>{condition?.arithmeticParamUnit}</span> }
    </>
    : condition?.isTriggerParamTypeEnum ? <span className='trigger-condition-bold'>{'('}{enumValues?.filter(item=>condition?.triggerParamEnumValue?.includes(item?.value))?.map(item=>item?.label).join(', ')}{')'}</span>
    : condition?.isTriggerParamTypeDate && isInteger(Number(condition?.triggerParameter1Value)) ? <span className='trigger-condition-bold'>{'( Last '}{condition?.triggerParameter1Value}{' days )'}</span>
    : condition?.triggerParameter2Value ? 
      <>
      <span className='trigger-condition-bold'> {'('} {condition?.triggerParameter1Value} , {condition?.triggerParameter2Value} {')'} </span>
      { condition?.triggerParamUnit && <span className='trigger-condition-bold'>{condition?.triggerParamUnit}</span> }
     </>
    :<>
      <span className='trigger-condition-bold'>{condition?.triggerParameter1Value}</span>
      { condition?.triggerParamUnit && <span className='trigger-condition-bold'>{condition?.triggerParamUnit}</span> }
    </>

    
    
    return <div className='trigger-condition-container'>
      <span className='trigger-condition-normal'>{'('}</span>
      <span className='trigger-condition-bold'>&quot;{condition?.triggerParamLabel}&quot;</span>
      <span className='trigger-condition-normal'>{operatorRef?.filter(item => item?.id === condition?.triggerOperator)?.[0]?.label}</span>
      {value}
      <span className='trigger-condition-normal'>{')'}</span>
    </div>
  }

  const parseExpression = (expression:string) => {
    const tokens = expression?.split(' ');
    const updatedTokens = tokens.map(token => {
      return isOperator(token) ? <span className='trigger-condition-normal'>{token}</span> : getCondition(token);
    })
    return updatedTokens;
  }

  function addOrdinalSuffix(num: number): string {
    const lastTwo = num % 100;

    if (lastTwo >= 11 && lastTwo <= 13) {
      return `${num}th`;
    }

    switch (num % 10) {
      case 1: return `${num}st`;
      case 2: return `${num}nd`;
      case 3: return `${num}rd`;
      default: return `${num}th`;
    }
  }

  return (
    <>
      <Box
        sx={{
          width: 500,
          minHeight:160,
          border: '1px solid #00BFBF',
          borderRadius: '12px',
          padding: 2,
          backgroundColor: '#fff',
          borderLeft:'7px solid #00BFBF '
        }}>
          <Handle type="source" position={Position.Bottom} className='transparent-handle'/>
          <Handle type="source" position={Position.Left} className='transparent-handle' id='left'/>

          {/* Title with icon */}
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <IconWithTooltip iconClassName={'define_execution__bolt_black__icon'} /> 
            <Typography sx={{ fontWeight: '500', fontSize: '15px',marginBottom:'5px' }}>Trigger</Typography>
             <IconButton
                size="small"
                onClick={() => { }}
                sx={{
                    position: 'absolute',
                    right: '8px',
                    top: '8px',
                }}
            >
                <CloseIcon
                    onClick={() => removeNode()}
                    fontSize="small"
                    sx={{ color: '#666' }} />
            </IconButton>
          </Box>

          <div style={{display:'flex',gap:'6px'}}>
            <IconWithTooltip iconClassName={'rule__engine__form__schedule__execution__icon'} />
            <Typography sx={{ fontWeight: '500', fontSize: '14px',marginBottom:'5px' }}>When</Typography>
          </div>


          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minHeight: '35px', backgroundColor: '#EEFFFF', borderRadius: '10px',justifyContent:'space-between',padding:'4px' }}>    
            {
              executionPlan?.trigger?.expression ?
                <div className='advance__rule__engine__complete__trigger-condition'>{parseExpression(executionPlan?.trigger?.expression)}</div>
               :
                <div style={{display:'flex',alignItems:'center'}}>          
                  <div style={{fontSize:'12px'}}>
                  ((Parameter),(Operator),(Value))
                  </div>
                </div>
            }

            <IconButton
              size="small"
              onClick={handleEdit}
            >
              <EditIcon fontSize="small" sx={{ color: '#666' }} />
            </IconButton>
          </div> 

        <div className='advance__logic__enable__disable__toggle__container'>
            <div className='advance__logic__enable__disable__toggle__container-label'>
              <div className='advance__logic__enable__disable__toggle__container-label-left'>
                <Icon iconClassName='set-parameter-sidebar'/>
              </div>
              <div className='advance__logic__enable__disable__toggle__container-label-right'>
                <div className='advance__logic__enable__disable__toggle__container-label-text'>Advance Logic</div>
                <IconWithTooltip iconClassName={'info-icon'}  toolTipText={'Advance logic'}/>
              </div>
            </div>
            <div className='advance__logic__enable__disable__toggle-btn'>
                <CustomSwitch
                  switchId='advance-logic-enable-switch'
                  switchClassName='advance__logic__enable__switch'
                  checked={toggleSwitchConfig?.checked}
                  // switchLabelName={toggleSwitchConfig?.switchLabelName}
                  // disableSwitchLabelName={toggleSwitchConfig?.disableSwitchLabelName}
                  handleClick={() => { toggleSwitchConfig?.handleClick?.() }}
                  isDisabled={toggleSwitchConfig?.isDisabled ?? false}
                  customSpacing={0}
                />
            </div>
        </div>

        {
          executionPlan?.trigger?.occurrenceLogic === 'advance' && <div className='advance__logic__tabs__container'>
            <HorizontalNavbar
              selectedNav={activeTab}
              onNavClick={(event, val) => { event?.stopPropagation(); handleTabClick(val) }}
              navList={tabs}
              disabledNav={ enablePersistenceTab(executionPlan?.trigger) ? [] : ['persistence']}
            />
          </div>
        }

        {
          executionPlan?.trigger?.occurrenceLogic === 'advance' && <div className='advance__logic__parameters__container'>
            {
              activeTab === 'occurences' ? <>
                <div className='advance__logic__parameters'>
                  {
                    advanceLogicParams?.map(param => {
                      return <div className='advance__logic__parameter' key={param?.id}>
                        <div className='advance__logic__parameter-label-container'>
                          <div className='advance__logic__parameter-label'>{param?.label}</div>
                          {
                            param?.description && <div className='advance__logic__parameter-description'>
                              {param?.description}
                            </div>
                          }
                        </div>
                        {
                          param?.valueType === 'input' ?
                            <div className='advance__logic__parameter-value'>
                              <CustomInput
                                  inputValue={param?.value ? param?.value : ''}
                                  inputFieldId={'advance__logic__parameter-value-container-' + param?.id}
                                  className={'advance__logic__parameter-value-container'}
                                  isRequired={false}
                                  inputType={'text'} 
                                  handleInputChange={(e) => {
                                    const value = e.target.value;
                                    if (!/^\d*$/.test(value)) {
                                      toast.warn('Only digits are allowed');
                                      return;
                                    }
                                    param?.onValueChange(value);
                                  }}
                                  handleKeyPress={(e) => {
                                    if (['.', '+', '-', 'e'].includes(e.key)) {
                                      e.preventDefault();
                                      toast.warn('Only digits are allowed');
                                    }
                                  }}
                              />
                            </div>
                            :
                            <div className='advance__logic__parameter-value-multi-option-container'>
                              {
                                param?.options?.map((option) => {
                                  return <span key={option.id} className={executionPlan?.trigger?.timeUnit === option?.value ? 'advance-logic-multi-options-selected' : 'advance-logic-multi-options'}
                                    onClick={() => { param?.onValueChange(option?.value) }}
                                  >{option?.name}</span>
                                })
                              }
                            </div>
                        }
                      </div>
                    })
                  }
                </div>
                <div className='advance__logic__consecutive__session__toggle'>
                  <div className='consecutive__session__label__container'>
                    <div className={`consecutive__session__label ${consecutiveSessionToggleSwitchConfig?.isDisabled ? 'disabled' : 'enabled'}`}>Consecutive Sessions</div>
                    <IconWithTooltip iconClassName={'info-icon'}  toolTipText={'Consecutive session logic can be defined using only a single ‘Session Parameter’ condition.'}/>
                  </div>
                  <div className='advance__logic__consecutive__session__toggle-btn'>
                    <CustomSwitch
                      switchId='advance-logic-consecutive-session-enable-switch'
                      switchClassName='advance__logic__consecutive__session__enable__switch'
                      checked={consecutiveSessionToggleSwitchConfig?.checked}
                      handleClick={() => { consecutiveSessionToggleSwitchConfig?.handleClick?.() }}
                      isDisabled={consecutiveSessionToggleSwitchConfig?.isDisabled}
                    />
                  </div>
                </div>
                <div className='advance__logic__description'> {
                    executionPlan?.trigger?.isConsecutive ? 
                    `Execute only on ${executionPlan?.trigger?.numberOfOccurrences ? addOrdinalSuffix(executionPlan?.trigger?.numberOfOccurrences) : 'Xth'} occurrence in consecutive sesssions${executionPlan?.trigger?.timePeriod ? ` within ${executionPlan?.trigger?.timePeriod} ${executionPlan?.trigger?.timeUnit ? executionPlan?.trigger?.timeUnit : 'minute'}`: ''}; skip the rest.`
                    :
                    `Execute only on ${executionPlan?.trigger?.numberOfOccurrences ? addOrdinalSuffix(executionPlan?.trigger?.numberOfOccurrences) : 'Xth'} occurrence  ${executionPlan?.trigger?.timePeriod ? `within ${executionPlan?.trigger?.timePeriod} ${executionPlan?.trigger?.timeUnit ? executionPlan?.trigger?.timeUnit : 'minute'}` : ''}; skip the rest.`
                  } </div>
              </>
              :
              <>
                <div className='advance__logic__parameters'>
                  {
                    persistanceLogicParams?.map(param => {
                      return <div className='advance__logic__parameter' key={param?.id}>
                        <div className='advance__logic__parameter-label-container'>
                          <div className='advance__logic__parameter-label'>{param?.label}</div>
                          {
                            param?.description && <div className='advance__logic__parameter-description'>
                              {param?.description}
                            </div>
                          }
                        </div>
                        <div className='advance__logic__parameter-value'>
                          <CustomInput
                            inputValue={param?.value ? param?.value : ''}
                            inputFieldId={'advance__logic__parameter-value-container-' + param?.id}
                            className={'advance__logic__parameter-value-container'}
                            isRequired={false}
                            inputType={'text'}
                            handleInputChange={(e) => {
                                    const value = e.target.value;
                                    if (!/^\d*$/.test(value)) {
                                      toast.warn('Only digits are allowed');
                                      return;
                                    }
                                    param?.onValueChange(value);
                                  }}
                                  handleKeyPress={(e) => {
                                    if (['.', '+', '-', 'e'].includes(e.key)) {
                                      e.preventDefault();
                                      toast.warn('Only digits are allowed');
                                    }
                                  }}
                          />
                        </div>
                      </div>
                    })
                  }
                </div>
              </>
            }
        </div>
        }
      </Box>
      {
        isTriggerParameterPopoverOpen && <SidePopover
          id='advance__rule__engine__trigger__parameter__when__side__popover'
          open={isTriggerParameterPopoverOpen}
          headerText={'When'}
          headerSecondaryText='Trigger Condition'
          containerClassName='advance__rule__engine__detail__popover'
          handleClose={()=>{}}
          popperClassName='advance__rule__engine__trigger__point__side__popover'
          headerClassName={'advance__rule__engine__header__config'}
          horizontalLinePopover={true}
          isRuleEnginePopOver={true}
          headingIconClassName={'rule__engine__form__schedule__execution__icon'}
          ruleEngineSidePopoverOnclose={handleCloseTriggerParameterPopover}
          // eslint-disable-next-line react/no-children-prop
          children = {
            <TriggerPointSidePopover executionPlan={executionPlan} handleUpdateExecutionPlan={handleUpdateExecutionPlan} handleClose={handleCloseTriggerParameterPopover}/>
          } 
        />
      }
    </>
  );
};

export default ParameterNode;
